import React from 'react';
import { useDispatch } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { clear } from '../../store/reducers/authReducer';

export const UserSidebarMenu = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleLogout = (event) => {
        event.preventDefault();
        dispatch(clear());
        navigate('/');
    };

    return (
        <ul className="list-group">
            <li className="list-group-item d-flex justify-content-center align-items-center">
                <span className="fad fa-user fa-5x fa-fw text-primary my-3"></span>
            </li>
            <NavLink className="list-group-item list-group-item-action" to="/user" end={true}>
                <span className="fal fa-user fa-fw me-2"></span>
                Profile
            </NavLink>
            <NavLink className="list-group-item list-group-item-action" to="/user/orders">
                <span className="fal fa-file-invoice fa-fw me-2"></span>
                Orders
            </NavLink>
            <Link className="list-group-item list-group-item-action" to="#" onClick={handleLogout}>
                <span className="fal fa-sign-out-alt fa-fw me-2"></span>
                Logout
            </Link>
        </ul>
    );
};
